import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import { noop } from 'lodash-es';
import { ALL as allDevices } from '../../../models/device-type';
import { ALL as allSources } from '../../../models/source-types';
import { THIS_MONTH } from '../models/period';

const style = {
  backgroundColor: '#e5e6e6',
  borderRadius: '6px',
  marginLeft: '15px',
  border: 'none',
  fontSize: '13px'
};

const getDefaultDates = () => {
  const now = new Date();
  const toDay = dateFormat(now, 'yyyy-mm-dd');
  const fromDay = dateFormat(new Date(now.getFullYear(), now.getMonth(), 1), 'yyyy-mm-dd');
  const period = THIS_MONTH;
  return { toDay, fromDay, period };
};

const DEFAULT_FILTERS = Object.assign({}, getDefaultDates(), {
  device: allDevices,
  source: allSources
});

class ClearFilters extends Component {
  clearFilters = () => {
    this.props.onFiltersChange(DEFAULT_FILTERS);
  };

  render() {
    return (
      <button style={style} onClick={this.clearFilters}>
        Reset
      </button>
    );
  }
}

ClearFilters.propTypes = {
  onFiltersChange: PropTypes.func
};

ClearFilters.defaultProps = {
  onFiltersChange: noop
};

export default ClearFilters;
